import React from 'react'
import Layout from './../../../components/help/Layout/Layout'
import Seo from './../../../components/help/Seo'
import Header from '../../../components/ui/Header/Header'
import Intro from '../../../components/ui/Intro/Intro'
import Development from '../../../components/pages/About/Development/Development'
import Competencies from '../../../components/pages/About/Competencies/Competencies'
import Slogan from '../../../components/pages/About/Slogan/Slogan'
import CompanyNumbers from '../../../components/pages/About/CompanyNumbers/CompanyNumbers'
import Awards from '../../../components/pages/About/Awards/Awards'
import { getHrefToHome } from '../../../utils/getHrefToHome'
import { useStaticQuery, graphql } from 'gatsby'
import coverDesktopWide from '../../../images/about/cover_1920.jpg'
import coverDesktop from '../../../images/about/cover_1440.jpg'
import coverTabletA from '../../../images/about/cover_1024.jpg'
import coverTabletP from '../../../images/about/cover_768.jpg'
import coverMobile from '../../../images/about/cover_360.jpg'

const AboutPage = () => {
    const lang = 'en'

    const hrefHome = getHrefToHome(lang)

    const data = useStaticQuery(graphql`
        {
            seo: datoCmsRenshinSeo(originalId: { eq: "114097347" }, locale: { eq: "en" }) {
                titleH1
                crumbsName
                bgDesktop {
                    url
                }
                bgTabletA {
                    url
                }
                bgTabletP {
                    url
                }

                bgMobile {
                    url
                }

                footerLinks {
                    title
                    url
                }
                seo {
                    title
                    description
                }
            }

            main: datoCmsRenshinSeo(originalId: { eq: "114097337" }, locale: { eq: "en" }) {
                crumbsName
            }
        }
    `)

    const photo = {
        1920: data.seo.bgDesktop?.url || coverDesktopWide,
        1440: data.seo.bgDesktop?.url || coverDesktop,
        1024: data.seo.bgTabletA?.url || coverTabletA,
        768: data.seo.bgTabletP?.url || coverTabletP,
        360: data.seo.bgMobile?.url || coverMobile
    }

    const breadCrumbs = [
        { name: `${data.main.crumbsName}`, href: `${hrefHome}`, current: false },
        { name: `${data.seo.crumbsName}`, current: true }
    ]

    return (
        <Layout lang={lang}>
            <Seo title={data.seo?.seo?.title} description={data.seo?.seo?.description} />
            <Header light lang={lang} />
            <Intro crumbs={breadCrumbs} title={`${data.seo.titleH1}`} photo={photo} lang={lang} />
            <Development lang={lang} />
            <Competencies lang={lang} />
            <CompanyNumbers lang={lang} />
            <Slogan lang={lang} />
            <Awards lang={lang} />
        </Layout>
    )
}

export default AboutPage
